"use client";
import { PartialPartner } from "@/common/partner/types";
import Icon from "@/components/icons";
import Image from "next/image";
import useTranslations from "@/i18n/useTranslations";
interface Props {
  sideRailTitle?: { text?: string };
}

type SideRailTitleProps = {
  text?: string;
  iconType?: string;
  partners?: PartialPartner[];
  partnerLogoOverride?: string | null;
};

export default function SideRailTitle({
  sideRailTitle,
  text,
  iconType = "certificate",
  partners,
  partnerLogoOverride,
}: Props & SideRailTitleProps) {
  const t = useTranslations("Common");
  const tCourse = useTranslations("Course");
  const { text: titleText } = sideRailTitle || {};
  const displayText = titleText ?? text ?? tCourse("earnCertificateTitle");

  const hasMultiplePartners = partners && partners.length > 1;

  const containerClassName = `flex ${hasMultiplePartners ? "flex-col md:flex-row" : ""} overflow-hidden items-center md:justify-center gap-4 md:gap-2`;
  const titleClassName = `text-primary-500 text-md md:text-xl m-0 font-bold text-center ${hasMultiplePartners ? "w-full md:w-auto" : ""}`;

  return (
    <div className={containerClassName}>
      <div className="flex gap-2">
        {partnerLogoOverride && partnerLogoOverride.trim() !== "" ? (
          <Image
            src={partnerLogoOverride}
            alt={t("programLogoAlt")}
            width={157}
            height={58}
            className="flex-shrink-0 md:hidden"
          />
        ) : (
          partners?.length &&
          partners.map((partner) => {
            return (
              <Image
                key={partner.uuid}
                src={partner.logoUrl}
                alt={t("programLogoAlt")}
                width={157}
                height={58}
                className="flex-shrink-0 md:hidden"
              />
            );
          })
        )}
      </div>
      <div className="hidden md:block">
        <Icon type={iconType} svgProps={{ width: 32, height: 32 }} />
      </div>
      <p className={titleClassName}>{displayText}</p>
    </div>
  );
}
